// extracted by mini-css-extract-plugin
module.exports = {"spinner":"_7273a8e"};